import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
import { message } from 'antd';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createReportDataAction = createActionCreator(constant.reportData, o => o);
export const createExportUrlAction = createActionCreator(constant.url, o => o);



let report = Urls.TaskStatisticUrl.report;
let exportUrl = Urls.TaskStatisticUrl.exportReport;

//获取数据统计（表格数据）
export const getReportData = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let search = getState().report.search;
            let response = await request(report + paramsEncode(Object.assign({}, search, { filtration: undefined })));
            dispatch(createReportDataAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

// 
export const handleSearch = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}


export const getExportUrl = (search) => {
    return (dispatch, getState) => {
        let search = getState().report.search;
        let url = exportUrl + paramsEncode(Object.assign({}, search, { filtration: undefined }));
        dispatch(createExportUrlAction(url));
    }
}




// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/report/action.js